export {
    default as TemplateSignUp,
    ITemplateSignUpProps,
} from './signup';
